(function($) {

	// var logger = $.Logger("activity");

	$.fn.activity = function(method, options) {
        // build main options before element iteration
        // Method calling logic
        var opts;
        if(methods[method])
        {
            opts = $.extend(true, {}, options);
        }
        else if(typeof method === 'object' || ! method)
        {
            opts = $.extend(true, {}, $.fn.activity.defaults, method);
        }
        else
        {
            $.error('Method ' + method + ' does not exist on jQuery.activity');
        }


        return this.each(function() {
             var $this = $(this);
             // build element specific options
            $this.options = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            //noinspection JSValidateTypes
            $this.options = $.fn.dataset ? $.extend(true, $this.options, $this.dataset()) : $this.options;

             // Method calling logic
             if(methods[method]) {
                 return methods[ method ].call(this, $this);
             } 
             else if(typeof method === 'object' || ! method) {
                 return methods.init.call(this, $this);
             }
         });
	};
	//
	// plugin defaults
	//
	$.fn.activity.defaults = {

	};  
    //
    // Methods
    //
    var methods = {
        'init' : function($this){
            //var options = $this.options;

            $this.on('click', '.activity-data-link', function(){
                loadData($this, $(this).attr('href'));
                return false;
            });

            var $startDatePicker = getStartDatePicker($this);
            var $endDatePicker = getEndDatePicker($this);
            getDatePickers($this).on('change', function(){
                var $datepicker = $(this);
                var newStartDate = $startDatePicker.datepicker('getDate');
                var newEndDate = $endDatePicker.datepicker('getDate');
                if (newStartDate && newEndDate) {
                    // restrict date range to 31 days
                    var days = moment(newEndDate).diff(moment(newStartDate), 'days');
                    if (days > 30) {
                        if ($datepicker.is('.form-date-range-left')) {
                            if(moment(newStartDate).date()==1) {
                                newEndDate = moment(newStartDate).add(1, 'month').subtract(1, 'day').toDate();
                            }
                            else {
                                newEndDate = moment(newStartDate).add(30, 'days').toDate();
                            }
                        }
                        else {
                            if(moment(newEndDate).add(1, 'day').date()==1) {
                                newStartDate = moment(newEndDate).date(1).toDate();
                            }
                            else {
                                newStartDate = moment(newEndDate).subtract(30, 'days').toDate();
                            }
                        }
                    }
                    $startDatePicker.datepicker("option", "maxDate", newEndDate);
                    $endDatePicker.datepicker("option", "minDate", newStartDate);

                    var url = $this.find('.activity-data-link').first().attr('href');
                    url = replaceUrlDate(replaceUrlDate(url, 'startDate', newStartDate), 'endDate', newEndDate);
                    loadData($this, url);
                }
            });
        },
        'loadDate' : function($this) {
            var options = $this.options;
            if(!options.date)
            {
                $.error('jQuery.activityTimesheet.loadDate options must contain a date');
            }

            var newDate = moment(options.date);
            var newStartDate = getStartDatePicker($this).datepicker('getDate');
            var newEndDate = getEndDatePicker($this).datepicker('getDate');
            if(moment(newEndDate).isBefore(newDate) || moment(newStartDate).isAfter(newDate)) {
                // newDate is not displayed in the current view so we shift the view to contain the date whilst maintaining the period size

                // does the selected date range represent a complete calendar month?
                var isMonth = moment(newStartDate).date() == 1 && moment(newEndDate).add(1, 'day').date() == 1;
                if (isMonth) {
                    // maintain the month span, even though months are different lengths
                    newStartDate = newDate.clone().date(1).toDate();
                    newEndDate = newDate.clone().add(1, 'month').date(1).subtract(1, 'day').toDate();
                }
                else {
                    // maintain days span
                    var days = moment(newEndDate).diff(moment(newStartDate), 'days') + 1;

                    var periods;
                    if(moment(newEndDate).isBefore(newDate)) {
                        periods = Math.ceil((newDate.diff(moment(newEndDate), 'days') / days));
                    } else {
                        periods = Math.floor((newDate.diff(moment(newStartDate), 'days') / days));
                    }

                    newStartDate = moment(newStartDate).add(periods*days, 'days').toDate();
                    newEndDate = moment(newEndDate).add(periods*days, 'days').toDate();
                }
            }

            var url = $this.find('.activity-data-link').first().attr('href');
            url = replaceUrlDate(replaceUrlDate(url, 'startDate', newStartDate), 'endDate', newEndDate);
            loadData($this, url);
        }
    };
    //
    // Private functions
    //

    //noinspection JSCommentMatchesSignature
    /**
     * Load the given timesheetData into the timesheet view and update the date filters accordingly
     * @param url /fpm/activity/timesheetData + queryString
     */
    function loadData($this, url) {
        var $panelContent = getPanel($this);
        if(url && !$panelContent.hasClass('panel-content-loading')) {

            $panelContent.addClass('panel-content-loading');
            var $datePickers = getDatePickers($this);
            $datePickers.prop('disabled', true);
            var $controlBar = getControlBar($this);
            $controlBar.find('.ui-button').button( "disable" );
            var params = getJsonFromUrl(url);
            var newStartDate = moment(params['startDate']).toDate();
            var newEndDate = moment(params['endDate']).toDate();
            setDateRange($this, newStartDate, newEndDate);

            var classes = [];
            var classNames = $panelContent.attr('class').split(' ');
            $.each(classNames, function (i, className) {
                if(className != 'panel-content-loading' && className.indexOf('panel-content-')===0) {
                    classes.push(className);
                    $panelContent.removeClass(className);
                }
            });
            $('<div class="loading-spinner-overlay" />').appendTo($panelContent);
            var $spinner = $('<div class="loading-spinner"/>').appendTo($panelContent);
            var spinner = Spinners.create($spinner, $.fn.msxitabs.defaults.spinner).play();
            $panelContent.load(url, function () {
                $.each(classes, function (i, className) {
                    $panelContent.addClass(className);
                });
                $panelContent.msxiinit();
                spinner.remove();
                $spinner.remove();
                $panelContent.removeClass('panel-content-loading');
                $datePickers.prop('disabled', false);
                $controlBar.find('.ui-button').button( "enable" );
            });
        }
    }

    //noinspection JSCommentMatchesSignature
    /**
     * Updates all navigation controls to reflect a newly displayed date range
     * @param newStartDate
     * @param newEndDate
     */
    function setDateRange($this, newStartDate, newEndDate) {
        var $startDatePicker = getStartDatePicker($this);
        var $endDatePicker = getEndDatePicker($this);
        var oldStartDate = $startDatePicker.datepicker( "getDate");
        // Because of the min and max dates on a date range the order that the new dates are applied is dependant on whether we are moving the dates forward or backward
        if (newStartDate < oldStartDate) {
            setDatePickerDateAndTriggerOnSelect($startDatePicker, newStartDate);
            setDatePickerDateAndTriggerOnSelect($endDatePicker, newEndDate);
        } else {
            setDatePickerDateAndTriggerOnSelect($endDatePicker, newEndDate);
            setDatePickerDateAndTriggerOnSelect($startDatePicker, newStartDate);
        }

        // read the dates back from the date pickers incase the submitted dates were not honored (e.g. due to min and max constraints)
        newStartDate = $startDatePicker.datepicker('getDate');
        newEndDate = $endDatePicker.datepicker('getDate');

        // does the selected date range represent a complete calendar month?
        var isMonth = moment(newStartDate).date() == 1 && moment(newEndDate).add(1, 'day').date() == 1;

        var previousStartDate;
        var previousEndDate;
        var nextStartDate;
        var nextEndDate;
        if (isMonth) {
            // maintain the month span, even though months are different lengths
            previousStartDate = moment(newStartDate).subtract(1, 'month').toDate();
            previousEndDate = moment(newEndDate).date(1).subtract(1, 'day').toDate();
            nextStartDate = moment(newStartDate).add(1, 'month').toDate();
            nextEndDate = moment(newEndDate).add(2, 'months').date(1).subtract(1, 'day').toDate();
        }
        else {
            // maintain days span
            var days = moment(newEndDate).diff(moment(newStartDate), 'days') + 1;
            previousStartDate = moment(newStartDate).subtract(days, 'days');
            previousEndDate = moment(newEndDate).subtract(days, 'days');
            nextStartDate = moment(newStartDate).add(days, 'days');
            nextEndDate = moment(newEndDate).add(days, 'days');
        }
        updateHrefDateRange(getPreviousButton($this), 'startDate', previousStartDate, 'endDate', previousEndDate);
        updateHrefDateRange(getNextButton($this), 'startDate', nextStartDate, 'endDate', nextEndDate);

        updateHrefDateRange(getCurrentButton($this), 'startDate', newStartDate, 'endDate', newEndDate);

        updateHrefDateRange(getCreateButton($this), 'scheduledStartDate', newStartDate, 'scheduledEndDate', newStartDate);
    }

    /**
     * Updates the startDate and endDate parameters in a href to to the given start and end dates
     */
    function updateHrefDateRange($a, newStartDateName, newStartDate, newEndDateName, newEndDate) {
        if ($a.size() > 0) {
            $a.attr('href', replaceUrlDate(replaceUrlDate($a.attr('href'), newStartDateName, newStartDate), newEndDateName, newEndDate));
        }
    }

    /**
     * Replace the value of parameter dateName in url with date
     */
    function replaceUrlDate(url, dateName, date) {
        return url.replace(new RegExp(dateName + '=\\d{4}-\\d{2}-\\d{2}'), dateName + '=' + moment(date).format('YYYY-MM-DD'));
    }

    /**
     * Sets the given date on a datepicker and triggers the onSelect event
     */
    function setDatePickerDateAndTriggerOnSelect($datepicker, date) {
        var existingDate = $datepicker.datepicker("getDate");
        if (existingDate.getTime() != date.getTime()) {
            $datepicker.datepicker("setDate", date);
            // calling setDate does not trigger the onClose callback, which is necessary to keep the min and max date
            // up-to-date
            var inst = $.datepicker._getInst($datepicker[0]);
            $.datepicker._get(inst, 'onClose').apply(inst.input[0], [date, inst]);
        }
    }

    /**
     * Get a JSON object representing the parameters from a query string
     */
    function getJsonFromUrl(url) {
        var result = {};
        url.split("?")[1].split("&").forEach(function(part) {
            var item = part.split("=");
            result[item[0]] = decodeURIComponent(item[1]);
        });
        return result;
    }

    function getControlBar($this) {
        return $this.find('.activity-control-bar');
    }

    function getDatePickers($this) {
        return $this.find('.activity-control-bar  .date-picker');
    }

    function getStartDatePicker($this) {
        return $this.find('.activity-control-bar .form-date-range-left');
    }

    function getEndDatePicker($this) {
        return $this.find('.activity-control-bar .form-date-range-right');
    }

    function getPanel($this) {
        return $this.find('.activity > .panel-content');
    }

    function getPreviousButton($this) {
        return $this.find('.activity-control-bar .activity-data-link-previous');
    }

    function getNextButton($this) {
        return $this.find('.activity-control-bar .activity-data-link-next');
    }

    function getCurrentButton($this) {
        return $this.find('.activity-control-bar .activity-data-link-current');
    }

    function getCreateButton($this) {
        return $this.find('.activity-control-bar .activity-create');
    }

})(jQuery);